export default __webpack_public_path__ + "static/media/cotizacion.21c9ba3c.jpg";